import Icon from 'components/icon/Icon';
import { round } from 'modules/common';

import { Number, Wrapper } from './Rating.styles';

export interface RatingProps {
  rating: number;
  ratingCount: number;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}

const Rating = ({
  className,
  rating,
  ratingCount,
  size = 'sm',
  label,
}: RatingProps): JSX.Element => {
  const tooltipText = rating
    ? `${label ? `${label}: ` : ''}${round(
        rating,
        1
      )}/5 stars (${ratingCount} ratings)`
    : `${label ? `${label}: ` : ''}Not rated yet`;

  return (
    <Wrapper size={size} className={className} data-tip={tooltipText}>
      <Icon type="star" size={size} color="gray" />
      <Number size={size}>{rating ? round(rating, 1) : '-'}</Number>
    </Wrapper>
  );
};

export default Rating;
